import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PersistentDropdown } from './persistent-dropdown.component'
import { PersistentDropdownOption } from './persistent-dropdown-option.component'
import { PersistentDropdownService } from './persistent-dropdown.service'
import { OptValueDirective } from './option-value.directive'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'

@NgModule({
  declarations: [
    PersistentDropdown,
    PersistentDropdownOption,
    OptValueDirective
  ],
  imports: [
    CommonModule,
    BsDropdownModule
  ],
  exports: [
    PersistentDropdown,
    PersistentDropdownOption,
    OptValueDirective
  ],
  providers: [
    PersistentDropdownService
  ]
})
export class PersistentDropdownModule {}
